<script setup lang="ts">
import { useKantonByKuerzel } from '@/composables/kanton'
import { Kanton } from '@/models/Kanton'
import { onMounted, ref, type Ref } from 'vue'

const modelValue = defineModel<string | string[] | null>()

const { multi = false } = defineProps<{
    multi?: boolean
}>()

const kantone: Ref<Kanton[]> = ref([])

onMounted(async () => {
    const tg = await useKantonByKuerzel('TG')
    const sh = await useKantonByKuerzel('SH')
    if (tg && sh) {
        kantone.value = [tg, sh]
    }
})
</script>

<template>
    <div>
        <v-row v-if="multi">
            <v-col
                v-for="(kantonObj, idx) in kantone"
                :key="idx"
                :value="kantonObj.kuerzel"
                cols="6"
                sm="2"
                md="4"
            >
                <v-checkbox v-model:model-value="modelValue" :value="kantonObj.kuerzel">
                    <template v-slot:label>
                        <img :src="kantonObj.icon || ''" width="24px" class="mr-2" />
                        {{ kantonObj.kurz }}
                    </template>
                </v-checkbox>
            </v-col>
        </v-row>
        <v-radio-group v-else v-model:model-value="modelValue">
            <v-radio v-for="(kantonObj, idx) in kantone" :key="idx" :value="kantonObj.kuerzel">
                <template v-slot:label>
                    <img :src="kantonObj.icon || ''" width="24px" class="mr-2" />
                    {{ kantonObj.kurz }}
                </template>
            </v-radio>
        </v-radio-group>
    </div>
</template>
